import { Button } from '@chakra-ui/react'
import React from 'react'

const FailedButton = () => {
  return (
    <Button bgColor={"rgba(241, 59, 31, 1)"} adding="0 20px " borderRadius="35px">Failed</Button>
  )
}

export default FailedButton